"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.StubIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 32 32" },
    react_1.default.createElement("rect", { width: "32", height: "32", fill: "#ffffff", stroke: "#44C0A2", strokeWidth: "2" }),
    react_1.default.createElement("line", { x1: "0", y1: "0", x2: "32", y2: "32", stroke: "#44C0A2", strokeWidth: "2" }),
    react_1.default.createElement("line", { x1: "32", y1: "0", x2: "0", y2: "32", stroke: "#44C0A2", strokeWidth: "2" }))); };
//# sourceMappingURL=StubIcon.js.map